import { View } from 'foundations-components/components/View';
import { Media, MediaBody, MediaLeft } from 'foundations-components/transitional/components/Media';
import AvatarIcon from '../AvatarIcon';
import LabelSkeleton from './LabelSkeleton';
import PropertiesListSkeleton from './PropertiesListSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContactCompanyDetailsSkeleton = ({
  numberOfProperties
}) => {
  return /*#__PURE__*/_jsxs(Media, {
    spacing: "medium",
    align: "start",
    children: [/*#__PURE__*/_jsx(MediaLeft, {
      children: /*#__PURE__*/_jsx(AvatarIcon, {
        size: "large"
      })
    }), /*#__PURE__*/_jsxs(MediaBody, {
      paddingBlockStart: "50",
      children: [/*#__PURE__*/_jsx(View, {
        marginBlockEnd: "400",
        marginBlockStart: "100",
        children: /*#__PURE__*/_jsx(LabelSkeleton, {})
      }), /*#__PURE__*/_jsx(PropertiesListSkeleton, {
        numberOfProperties: numberOfProperties
      })]
    })]
  });
};
export default ContactCompanyDetailsSkeleton;